export default __webpack_public_path__ + "static/media/logoBranco.f29e71f2.png";